import { motion } from "framer-motion";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-[100] bg-white flex items-center justify-center">
      <div className="relative flex flex-col items-center gap-8">
        {}
        <div className="relative w-16 h-16">
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 90, 180, 270, 360],
              borderRadius: ["20%", "50%", "20%"],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="w-full h-full border-2 border-black"
          />
          <motion.div
            animate={{
              scale: [0.5, 0.8, 0.5],
              rotate: [360, 270, 180, 90, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute inset-0 m-auto w-8 h-8 bg-black"
          />
        </div>

        {}
      </div>
    </div>
  );
};

export default Loading;
